import { minBy } from 'lodash';

const defaultOptions = {
    max: 10,
    expiredMs: 0,
    name: 'COLLECT_CACHE_RECORD',
    delayTime: 2000,
};

export class LocalCache {
    constructor(options = {}) {
        this.options = { ...options, ...defaultOptions };
        try {
            const cacheStr = localStorage.getItem(this.options.name);
            this.cache = cacheStr ? JSON.parse(cacheStr) : {};
        } catch (error) {
            this.cache = {};
        }
        this.startTime = 0;
        this.timer = null;
        const keys = Object.keys(this.cache);
        if (keys.length > this.options.max) {
            const removeKey = minBy(keys, key => this.cache[key].time);
            this.remove(removeKey, false);
            this.resetStorageSync();
        }
    }

    setOptions(options = {}) {
        this.options = { ...this.options, ...options };
    }

    set(key, data) {
        console.log('[hal]:set', key, data, this.options.expiredMs);
        // if (!this.options.expiredMs) {
        //     return;
        // }
        const time = +new Date();
        this.cache[key] = {
            time,
            data,
        };
        this.resetStorage();
    }

    get(key) {
        return this.cache[key] ? this.cache[key].data : {};
    }

    clearExpired() {
        const now = +new Date();
        for (const key in this.cache) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.cache.hasOwnProperty(key)) {
                const item = this.cache[key];
                if (now - item.time > this.options.expiredMs) {
                    this.remove(key, false);
                }
            }
        }
        this.resetStorageSync();
    }

    remove(key, hasReset = true) {
        delete this.cache[key];
        hasReset && this.resetStorage();
    }

    removeSync(key, hasReset = true) {
        delete this.cache[key];
        hasReset && this.resetStorageSync();
    }

    resetStorage() {
        const now = +new Date();
        this.clearTimer();
        if (now - this.startTime >= this.options.delayTime) {
            this.resetStorageSync();
            this.startTime = now;
        } else {
            this.timer = setTimeout(() => {
                this.resetStorageSync();
                this.clearTimer();
            }, this.options.delayTime);
        }
    }

    clearTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    resetStorageSync() {
        this.clearTimer();
        localStorage.setItem(this.options.name, JSON.stringify(this.cache));
    }
}

export default new LocalCache();
